module.exports = __webpack_public_path__ + "media/country_flags/mg-5770e5aa.png";